import { render } from "./EmailInfo.vue?vue&type=template&id=6caba96a"
import script from "./EmailInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailInfo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/EmailInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6caba96a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6caba96a', __exports__)) {
    api.reload('6caba96a', __exports__)
  }
  
  module.hot.accept("./EmailInfo.vue?vue&type=template&id=6caba96a", () => {
    api.rerender('6caba96a', render)
  })

}


export default __exports__